// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__MHVAH","statItem":"Statistics_statItem__gf7eW","title_stat":"Statistics_title_stat__Lvu9A"};